import { render } from "./KeyboardControl.vue?vue&type=template&id=2eab7b0a&scoped=true"
import script from "./KeyboardControl.vue?vue&type=script&lang=js"
export * from "./KeyboardControl.vue?vue&type=script&lang=js"

import "./KeyboardControl.vue?vue&type=style&index=0&id=2eab7b0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eab7b0a"]])

export default __exports__